if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          // On mobile, scroll the horizontal media list to show active media
          if (!this.mql.matches) {
            const mediaList = activeMedia.closest('.product__media-list');
            if (mediaList) {
              mediaList.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
            } else if (activeMedia.parentElement) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
            }
          } else if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        const activeVideo = activeItem.querySelector('video');
        const mediaGallery = activeItem.closest('[id^="MediaGallery-"]');
        
        if (activeVideo) {
          // Reset video to start and unmute
          activeVideo.currentTime = 0;
          activeVideo.muted = false;
          
          // Mute or pause other videos
          document.querySelectorAll('video').forEach((video) => {
            if (video !== activeVideo) {
              const mediaItem = video.closest('.product__media-item');
              const isActive = mediaItem && mediaItem.classList.contains('is-active');
              if (!isActive) {
                // If in the same gallery, mute but keep playing; otherwise pause
                if (mediaGallery && mediaItem && mediaItem.closest('[id^="MediaGallery-"]') === mediaGallery) {
                  video.muted = true;
                } else {
                  video.pause();
                }
              }
            }
          });
          
          // Reset and unmute external videos (YouTube/Vimeo) if they exist in activeItem
          const activeYoutube = activeItem.querySelector('.js-youtube');
          const activeVimeo = activeItem.querySelector('.js-vimeo');
          if (activeYoutube) {
            activeYoutube.contentWindow.postMessage('{"event":"command","func":"seekTo","args":[0,true]}', '*');
            activeYoutube.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
          }
          if (activeVimeo) {
            activeVimeo.contentWindow.postMessage('{"method":"setCurrentTime","value":0}', '*');
            activeVimeo.contentWindow.postMessage('{"method":"setVolume","value":1}', '*');
          }
        } else {
          // When switching to non-video media, mute videos in the same gallery but keep them playing
          // Pause videos outside the gallery
          if (mediaGallery) {
            // Mute videos in the same product gallery (keep playing)
            document.querySelectorAll('video').forEach((video) => {
              const videoMediaItem = video.closest('.product__media-item');
              const isInProductGallery = videoMediaItem && videoMediaItem.closest('[id^="MediaGallery-"]') === mediaGallery;
              if (isInProductGallery) {
                video.muted = true;
              } else {
                // Pause videos outside the gallery
                video.pause();
              }
            });
            // Mute external videos (YouTube/Vimeo) in the same gallery
            document.querySelectorAll('.js-youtube, .js-vimeo').forEach((video) => {
              const videoMediaItem = video.closest('.product__media-item');
              const isInProductGallery = videoMediaItem && videoMediaItem.closest('[id^="MediaGallery-"]') === mediaGallery;
              if (isInProductGallery) {
                // Mute external videos (they continue playing)
                if (video.classList.contains('js-youtube')) {
                  video.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                } else if (video.classList.contains('js-vimeo')) {
                  video.contentWindow.postMessage('{"method":"setVolume","value":0}', '*');
                }
              } else {
                // Pause external videos outside gallery
                if (video.classList.contains('js-youtube')) {
                  video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                } else if (video.classList.contains('js-vimeo')) {
                  video.contentWindow.postMessage('{"method":"pause"}', '*');
                }
              }
            });
          } else {
            // Not in product gallery, use normal pauseAllMedia
            window.pauseAllMedia();
          }
        }
        // Load deferred media (videos) immediately when activated
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && deferredMedia.loadContent) {
          deferredMedia.loadContent(false);
          // On mobile, ensure video is visible after loading
          if (!this.mql.matches) {
            setTimeout(() => {
              const video = activeItem.querySelector('video');
              if (video) {
                video.style.display = 'block';
                video.style.visibility = 'visible';
                video.style.opacity = '1';
              }
            }, 100);
          }
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
